import React from 'react';
import { colors } from 'styleguide/colors';
import styled, { ThemeProps } from 'styled-components';
import { P2 } from 'styleguide/Texts';
import { Icon } from 'styleguide/Icons/Icon';
import VerifiedBadge from './assets/verified-badge.svg';
import { Theme } from 'styleguide/types';
import { t } from 'translations/t';

const Content = styled.div`
  width: 100%;
  height: 100%;
  min-height: 308px;
  display: flex;
  text-align: left;
  border-radius: 4px;
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'light' ? colors.greyUltraLight : colors.greyDark};
`;

const InnerContent = styled.div`
  padding: 32px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const RatingStars = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;

interface ReviewCardProps {
  title: string;
  date: string;
  author: string;
  description: string;
}

export const ReviewCard = ({ title, date, author, description }: ReviewCardProps) => (
  <Content>
    <InnerContent>
      <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 32 }}>
        <div
          style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-start' }}
        >
          <RatingStars>
            <Icon type="star" tint={colors.primary} />
            <Icon type="star" tint={colors.primary} />
            <Icon type="star" tint={colors.primary} />
            <Icon type="star" tint={colors.primary} />
            <Icon type="star" tint={colors.primary} />
          </RatingStars>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <P2 type="secondary">{date}</P2>
        </div>
      </div>
      <P2 style={{ fontWeight: 600, marginBottom: 16 }}>{title}</P2>
      <P2>{description}</P2>
      <div style={{ display: 'flex', flex: 1, marginTop: 32, alignItems: 'flex-end' }}>
        <div
          style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-start' }}
        >
          <P2 style={{ fontWeight: 600 }}>
            {t('web.paywall.reviewCard.byAuthor', { name: author })}
          </P2>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <VerifiedBadge />
          <P2 style={{ color: colors.primary, marginInlineStart: 4 }}>
            {t('web.paywall.reviewCard.verified')}
          </P2>
        </div>
      </div>
    </InnerContent>
  </Content>
);
